export default {
    questions: [],
    type: null,
    quizzes: [],
    answers: [],
    taskTranslations: [],
    taskTranslationId: null,
    hintTranslations: [],
    hintTranslationId: null,
    pictures: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/question/state.js